import React from 'react';
import { useSelector } from 'react-redux';
import sidebar from '@/css/module/sidebar.css';
import { SuggestedLayers } from '@/features/suggestions/components/SuggestedLayers';
import { ActiveSteps } from '@/containers/StepsSidebar/ActiveSteps';
import { InactiveSteps } from '@/containers/StepsSidebar/InactiveSteps';
import { AddStepsSuggestion } from '@/containers/StepsSidebar/AddStepsSuggestion';
import { Header } from '@/containers/StepsSidebar/Header';
import { AddNewStepControls } from '@/containers/StepsSidebar/AddNewStepControls';
import { createCustomEvent } from '@/util/createCustomEvent';
import { SCROLL } from '@/constants/custom-event-names';
import { HowDoISearch } from '@/components/HowDoISearch/HowDoISearch';
import { getUserActions } from '@/store-selectors';
import { userIsFinishedOnboarding } from '@/components/HighlightFeature';

let scrollPos = 0;

const handleScroll = (e: React.UIEvent<HTMLElement>) => {
  window.dispatchEvent(createCustomEvent(SCROLL));
  //
  // StepsSidebar is wrapped in <Resizable> which sets scrollTop to 0 whenever resizing.
  //   We don't want that to happen (as loses scroll position) so when it does, we reset it back to its previous position.
  //
  if (e.currentTarget.scrollTop === 0 && scrollPos > 200) {
    e.currentTarget.scrollTop = scrollPos;
  } else {
    scrollPos = e.currentTarget.scrollTop;
  }
};

export const QuerySteps: React.FC<any> = ({
  transitionsOn,
  lastAddStepButtonsOpened,
  setAddStepButtonsOpened,
}) => {
  const containerElRef = React.useRef<HTMLDivElement>(null);
  const userActions = useSelector(getUserActions);

  React.useEffect(() => {
    // @ts-expect-error: TODO: findout whether we need it at all.
    window.trevzSidebar = containerElRef.current;
  }, []);

  return (
    <div
      onScroll={handleScroll}
      className={sidebar.leftSectionInner}
      ref={containerElRef}
      data-quickfix-remove-on-refactoring
    >
      <AddStepsSuggestion />
      <Header />
      <div>
        <ActiveSteps
          transitionsOn={transitionsOn}
          lastAddStepButtonsOpened={lastAddStepButtonsOpened}
          setAddStepButtonsOpened={setAddStepButtonsOpened}
        />
        {userIsFinishedOnboarding(userActions) && <AddNewStepControls />}
        <InactiveSteps
          transitionsOn={transitionsOn}
          lastAddStepButtonsOpened={lastAddStepButtonsOpened}
          setAddStepButtonsOpened={setAddStepButtonsOpened}
        />
        {userIsFinishedOnboarding(userActions) && (
          <>
            <SuggestedLayers />
            <HowDoISearch />
          </>
        )}
        <div className={sidebar.buffer} />
      </div>
    </div>
  );
};
